import React from 'react';
import { Text } from '../general/Text';

interface LogRowProps {
  level: string;
  text: string;
  timestamp?: string | null;
}

function getLogColor(level: string): string {
  switch (level) {
    case 'error':
      return 'var(--color-danger)';
    case 'warn':
      return 'var(--color-warning)';
    default:
      return 'var(--color-text-primary)';
  }
}

function formatTimestamp(timestamp?: string | null): string | null {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
}

export const LogRow: React.FC<LogRowProps> = ({ level, text, timestamp }) => {
  const formattedTimestamp = formatTimestamp(timestamp);
  const color = getLogColor(level);

  return (
    <div style={{ width: '100%', textAlign: 'start', alignSelf: 'flex-start' }}>
      <Text
        variant='body3'
        style={{
          color,
          whiteSpace: 'normal',
          wordBreak: 'break-word'
        }}
      >
        <span>{'• '}</span>
        {formattedTimestamp && <span style={{ fontFamily: 'monospace' }}>{`[${formattedTimestamp}] `}</span>}
        {text}
      </Text>
    </div>
  );
};
